module.exports = __webpack_public_path__ + "Flag-31.73829b4ca5a2cb82fa10735a8fddf13c.svg";